import { render, staticRenderFns } from "./applyStatus.vue?vue&type=template&id=2b891048&scoped=true&"
import script from "./applyStatus.vue?vue&type=script&lang=js&"
export * from "./applyStatus.vue?vue&type=script&lang=js&"
import style0 from "./applyStatus.vue?vue&type=style&index=0&id=2b891048&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b891048",
  null
  
)

export default component.exports